import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Box, useIsMobile } from "@salestrak/ui";

import {
  SettingsMobileHeader,
  SettingsMobileHeaderContext,
} from "#app/components/navigation/settings-mobile-header";

function SettingsLayout() {
  const isMobile = useIsMobile();

  return (
    <SettingsMobileHeaderContext.Provider value={isMobile}>
      <Box fill="flex" direction="column">
        <SettingsMobileHeader />
        <Outlet />
      </Box>
    </SettingsMobileHeaderContext.Provider>
  );
}

export const Route = createFileRoute("/(app)/$workspace/settings")({
  component: SettingsLayout,
});
